export enum CampaignStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  SUCCESS = 'success',
  ERROR = 'error',
}
